<template>
  <b-modal title="Informações Sobre a Despesa" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="desc" label-cols-sm="3" label-align="right">
            <b-form-textarea v-model="editing.descricao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Data:" label-for="data" label-cols="3" label-align="right">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Valor:" label-for="valor" label-cols="3" label-align="right">
            <b-form-input id="valor" v-model.lazy="editing.valor" v-money="money" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Responsável:" label-for="resp" label-cols="3" label-align="right">
            <b-form-input id="resp" v-model="editing.responsavel" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEquipeStore } from "@/stores/EquipeStore";
import Despesa from "@/models/Despesa";
import Notificacao from "@/models/Notificacao";
import { VMoney } from "v-money";

export default {
  name: "ModalDeEdicaoDeDespesa",

  data() {
    return {
      show: false,
      editing: new Despesa(0, "Nova Despesa", new Date(), 0.0, ""),
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },

  directives: { money: VMoney },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.diarioStore.ALTERAR_DESPESA(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Despesa salva no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      } else {
        this.diarioStore.CADASTRAR_DESPESA(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Nova despesa salva no SGCQ com sucesso!", "Excelente!", "success"));
          this.$emit("update");
        });
      }
      this.show = !this.show;
    },

    call(diario) {
      this.show = !this.show;
      this.editing = diario;
    },
  },

  setup() {
    const store = useSgcqStore();
    const diarioStore = useEquipeStore();

    return {
      store,
      diarioStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
